import AdminAuthForm from '../components/AdminAuthForm/AdminAuthForm';

const AdminLogin = () => {
  return <AdminAuthForm />;
};

export default AdminLogin;
